<template>
      <div class="markup">
        <div class="markup__subtitle markup__subtitle_head">ТТ рекламы в ленте новостей Вконтакте</div>
        <div class="markup__h markup__h_4">
          Рекламные записи в Новостной ленте – формат, органично вписывающийся в интерфейс ВКонтакте. Формат размещается в ленте новостей и выглядит как пост из сообществ, на которые подписан пользователь.
          <br>
          <br>
          Возможность добавить практически любой контент к рекламируемой записи позволяет наилучшим образом рассказать о продукте или услуге.
        </div>
        <br>
        <div class="markup__h markup__h_3">
          <strong>Доступные форматы:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Запись с кнопкой</li>
          <li>Карусель</li>
          <li>Универсальная запись (с изображением, GIF, видео или сниппетом)</li>
          <li>Реклама сайта</li>
        </ul>

        <br>
        <br>

        <div class="markup__h markup__h_2">
          <strong>Запись с кнопкой</strong>
        </div>
        <div class="markup__h markup__h_4">
          Формат похож на универсальную запись, но имеет call-to-action кнопку, текст на которой можно изменять. Данный формат лучше всего подходит для генерации трафика и конверсий на сайте.
        </div>
        <div class="attention attention_info">
          <div class="attention__title">Важно знать: </div>
          <p><strong>Доступные названия кнопок:</strong> Перейти, Открыть, Подробнее, Записаться, Купить, Купить билет, В магазин, Установить, Заполнить, Заказать, Создать, Связаться, Попробовать, Начать, Получить, Слушать, Узнать, Смотреть, Скачать, Участвовать, Играть, Подать заявку, Получить предложение, Написать, Откликнуться</p>
        </div>
        <div class="markup__h markup__h_3">
          <strong>Необходимые материалы для размещения:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Текст записи может содержать не более 2000 символов, включая знаки препинания и пробелы, не более четырёх переносов строки (использование в тексте ссылок, в том числе хештегов, не допускается). <strong>Рекомендуемая длина текста с учетом знаков препинания и пробелов – 280 символов,</strong> так запись лучше воспринимается пользователями и не сворачивается при просмотре</li>
          <li>В тексте записи не разрешается использовать emoji (графические смайлики)</li>
          <li>
            Размер изображения или видео в сниппете должен быть не менее 537x240px и иметь аналогичное соотношение сторон
            <br>
            <strong>Обратите внимание:</strong> мы рекомендуем использовать видео с соотношением сторон [16:9], если вы используете другие размеры, при показе объявления в полной версии сайта к видео могут быть добавлены чёрные поля
          </li>
          <li>Текст на изображении в сниппете должен занимать не более 20% от общей площади фотографии</li>
          <li>Поддерживаемые форматы изображений: JPG, PNG или GIF (без анимации)</li>
          <li>Поддерживаемые форматы видео (должно быть загружено в плеер ВКонтакте): AVI, MP4, 3GP, MPEG, MOV, FLV, F4V, WMV, MKV, WEBM, VOB, RM, RMVB, M4V, MPG, OGV, TS, M2TS, MTS</li>
          <li>Текст сниппета рядом с кнопкой может содержать не более 80 символов, включая знаки препинания и пробелы</li>
          <li>Надпись для кнопки можно выбрать из предложенного списка. Список доступных надписей зависит от посадочной страницы объявления</li>
        </ul>

        <br>
        <br>

        <div class="markup__h markup__h_2">
          <strong>Карусель</strong>
        </div>
        <div class="markup__h markup__h_4">Формат Карусель позволяет добавить в одно рекламное объявление до десяти изображений, каждое — с собственной ссылкой.</div>
        <div class="attention attention_info">
          <div class="attention__title">Важно знать: </div>
          <p>К карусели можно добавить от 3 до 10 карточек, содержащих информацию о товарах и услугах.</p>
        </div>
        <div class="markup__h markup__h_3">
          <strong>Необходимые материалы для размещения:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>Каждая карточка состоит из статичного изображения, заголовка, цены — старой и/или новой, ссылки на сайт, сообщество, приложение или номер телефона и кнопки</li>
          <li>Текст записи может содержать не более 220 символов, включая знаки препинания и пробелы. В тексте не должно быть ссылок, хештегов и упоминаний</li>
          <li>В тексте записи не разрешается использовать emoji (графические смайлики)</li>
          <li>Заголовок карточки должен содержать от 3 до 25 символов</li>
          <li>Размер изображения в карусели должен быть не менее 400х400 px</li>
          <li>Поддерживаемые форматы изображений JPG, PNG или GIF (без анимации)</li>
          <li>Текст на изображении должен занимать не более 20% от общей площади фотографии</li>
        </ul>

        <br>
        <br>

        <div class="markup__h markup__h_2">
          <strong>Универсальная запись</strong>
        </div>
        <div class="markup__h markup__h_4">
          Формат выглядит как обычная запись пользователя или сообщества в новостной ленте, то есть это такой же блок с текстом, изображением, видео или GIF-анимацией.
          <br>
          <br>
          Универсальная запись подходит для выполнения различных задач — генерация трафика на внешние ресурсы, охвата целевой аудитории, продвижения внутри ВКонтакте, ретаргетинга и т.д.
        </div>
        <div class="attention attention_info">
          <div class="attention__title">Важно знать: </div>
          <ul class="markup__ul markup__ul_nested">
            <li>Универсальные рекламные записи размещаются только от имени сообществ (группы, публичной страницы, мероприятия).</li>
            <li>
              Если у вас нет своего сообщества, то мы можем помочь с созданием технического сообщества, которое будет необходимо для публикации рекламных постов. Для этого от вас потребуется:
              <ul class="markup__ul markup__ul_nested">
                <li>Название сообщества, от имени которого будет происходить размещение рекламных постов</li>
                <li>Изображение для главной обложки сообщества в разрешении 1920×768 в формате JPG или PNG</li>
                <li>Изображение для аватара сообщества с соотношением сторон 1:1 в формате JPG или PNG. Чем выше качество картинки, тем лучше</li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="html2pdf__page-break"/>

        <div class="markup__h markup__h_3">
          <strong>Необходимые материалы для размещения:</strong>
        </div>
        <ul class="markup__ul markup__ul_nested">
          <li>
            <div class="markup__h markup__h_3">
              <strong>Текст</strong>
            </div>
            <ul class="markup__ul markup__ul_nested">
              <li>Текст записи может содержать не более 16 384 символов, включая знаки препинания и пробелы, но лучше избегать объемных текстов, которые будут полностью отображаться только при нажатии кнопки «Показать еще».
              <strong>Рекомендуемая длина текста с учетом знаков препинания и пробелов – 280 символов,</strong> так запись лучше воспринимается пользователями и не сворачивается при просмотре</li>
              <li>В тексте могут содержаться прямые ссылки</li>
              <li>В тексте записи не разрешается использовать emoji (графические смайлики)</li>
            </ul>
          </li>
          <li>
            <div class="markup__h markup__h_3">
              <strong>Изображения</strong>
            </div>
            <ul class="markup__ul markup__ul_nested">
              <li>К записи можно добавить до 10 изображений в формате JPG, GIF (без анимации), TIF или PNG</li>
              <li>Если изображение в количестве одной единицы, то иметь разрешение должно быть не менее 537x240px и иметь аналогичное соотношение сторон</li>
              <li>Текст на изображении должен занимать не более 20% от общей площади фотографии</li>
            </ul>
          </li>
          <li>
            <div class="markup__h markup__h_3">
              <strong>GIF-анимация (опционально)</strong>
            </div>
            <ul class="markup__ul markup__ul_nested">
              <li>Вес файла с GIF-анимацией может быть не более 50 МБ. Автоплей GIF-анимации работает для файлов с весом не более 10-12 МБ</li>
              <li>Каждая из сторон GIF-изображения должна быть не более 1000 px</li>
              <li>GIF-изображение должно содержать более 1 кадра, интервал между кадрами от 0.01 до 1 секунды</li>
            </ul>
          </li>
          <li>
            <div class="markup__h markup__h_3">
              <strong>Видео (опционально)</strong>
            </div>
            <ul class="markup__ul markup__ul_nested">
              <li>Максимальный допустимый размер видеофайла – 2 ГБ</li>
              <li>Поддерживаемые форматы видео: AVI, MP4, 3GP, MPEG, MOV, FLV, F4V, WMV, MKV, WEBM, VOB, RM, RMVB, M4V, MPG, OGV, TS, M2TS, MTS</li>
              <li>Максимальное разрешение видеозаписи 1080р</li>
              <li>Поддерживаются горизонтальные, квадратные и вертикальные видеозаписи</li>
              <li>Доступна возможность встраивания видео с других видеохостингов (Youtube, Rutube, Vimeo и др)</li>
            </ul>
          </li>
          <li>
            <div class="markup__h markup__h_3">
              <strong>Сниппет (опционально)</strong>
            </div>
            <ul class="markup__ul markup__ul_nested">
              <li>Изображение в сниппете рядом с кнопкой должно иметь разрешение не менее 537x240px и аналогичное соотношение сторон</li>
              <li>Текст на изображении в сниппете должен занимать не более 20% от общей площади фотографии</li>
              <li>Поддерживаемые форматы изображений: JPG, PNG или GIF (без анимации)</li>
              <li>Текст сниппета рядом с кнопкой может содержать не более 80 символов, включая знаки препинания и пробелы</li>
            </ul>
          </li>
        </ul>

        <br>
        <br>

        <div class="html2pdf__page-break"/>

        <div class="markup__h markup__h_2">
          <strong>Порядок запуска кампании форматов ВК:</strong>
        </div>
        <ul class="markup__ul markup__ul_small markup__ul_clear">
          <li>1. Получение заполненного <a class="link" href="https://demo.buzzoola.com/buzz_vk_ads.xlsx" download>брифа</a> по форме</li>
          <li>2. Расчет медиаплана на размещение (1-3 рабочих дня)</li>
          <li>3. Получение брони и материалов для размещения</li>
          <li>4. Формирование токенов ОРД, заведение рекламной кампании, (1-3 дня)</li>
          <li>5. Старт размещения, снятие скриншотов</li>
        </ul>

        <br>
        <br>

        <div class="markup__h markup__h_2">
          <strong>Маркировка рекламы в ВК:</strong>
        </div>
        <br>
        <div class="markup__h markup__h_3">
          <strong>Что такое маркировка?</strong>
        </div>
        <br>
        <p>Всю рекламу ВКонтакте (и не только) необходимо дополнительно регистрировать, предоставляя операторам рекламных данных (ОРД) ИНН и другие документы, а также данные о кампаниях — они будут отправлять всю информацию в ЕРИР. Но это работает не так сложно, как кажется: VK разработала ПО, которое поможет автоматически маркировать креативы и передавать данные.</p>
        <br>
        <p>Маркировка — это токен или уникальный идентификатор рекламного объявления. Он зашифрован в виде буквенно-цифрового кода в ссылке, по которой пользователь переходит с креатива на сайт рекламодателя. По нему можно определить ОРД, который выдал токен на креатив, а также конечного заказчика рекламы.</p>
        <br>
        <div class="markup__h markup__h_3">
          <strong>Какие данные необходимо предоставлять:</strong>
        </div>
        <br>
        <p>Все участники рекламной цепочки должны передавать данные о кампаниях в ЕРИР. Часть информации важно передать до старта кампании, а другую — в течение 30 дней после окончания месяца, в котором размещалась реклама. Данные можно передавать в один ОРД или работать сразу с несколькими операторами.</p>
        <ul class="markup__ul markup__ul_nested">
          <li><strong>Для юридических лиц и ИП (резиденты РФ):</strong> ИНН, тип организации, номер договора (если вы заключали прямой договор)</li>
          <li><strong>Для юридических лиц и ИП (нерезиденты РФ):</strong> ИНН и тип организации, ОПФ и полное наименование, номер телефона, номер электронного средства платежа, регистрационный номер либо его аналог, номер налогоплательщика либо его аналог в стране регистрации, код страны регистрации юрлица в соответствии с ОКСМ</li>
          <li><strong>Для физлиц:</strong> ИНН и номер телефона, вид деятельности по ОКВЭД</li>
        </ul>
        <br>

        <a href="https://vk.com/@business-zakon-o-reklame" class="link">Подробнее про маркировку рекламы в ВК.</a>
        <br>
        <a href="https://vk.com/faq10060" class="link">Основные правила размещения рекламы в ленте ВК.</a>
        <br>

      </div>
</template>

<script>
export default {
  name: 'vkAds',
  components: {
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang='stylus'>
@import '../../../styles/darcula.min.css'
@import '../../../styles/main.styl'
@import '../../../styles/documentation_article_markup.styl'

</style>
